import Script from 'next/script';

export function RedoOrderTracking({ cms }) {
  return (
    <div
      id={`${RedoOrderTracking.Schema.key}-${
        cms.id || cms.cmsId || cms.tinaId
      }`}
    >
      <style>
        {`#${RedoOrderTracking.Schema.key}-${
          cms.id || cms.cmsId || cms.tinaId
        } {
            margin-top: ${cms.mobileSpacing}px;
          }
          @media(min-width: 1024px) {
            #${RedoOrderTracking.Schema.key}-${
          cms.id || cms.cmsId || cms.tinaId
        } {
              margin-top: ${cms.desktopSpacing}px;
            }
          }`}
      </style>
      <div id="redo-order-tracking-login-target">
      </div>
      <Script
        id="redo-config"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
          window.redoWidgetId = "p1wnnrcs47wd8yr";
          window.redoStorefront = {                                                                                                                                                       
          storeUrl: "briogeo-hair-care.myshopify.com",
          env: {                                                                                                                                                                        
            REDO_SHOPIFY_SERVER_URL: "https://shopify-server.getredo.com",
            REDO_RETURN_APP_URL: "https://returns.getredo.com",                                                                                                                         
          },                                                                                                                                                                            
          };
      `,
        }}
      />
      <Script
        src="https://shopify-extension.getredo.com/orderTrackingLogin.js"
        strategy="afterInteractive"
      />
    </div>
  );
}

RedoOrderTracking.displayName = 'RedoOrderTracking';

RedoOrderTracking.Schema = {
  category: 'Order Tracking',
  label: RedoOrderTracking.displayName,
  key: 'trackingform',
  fields: [
    {
      component: 'number',
      name: 'mobileSpacing',
      label: 'Section Top Margin - Mobile',
      defaultValue: 60,
    },
    {
      component: 'number',
      name: 'desktopSpacing',
      label: 'Section Top Margin - Desktop',
      defaultValue: 80,
    },
  ],
};
